import type { DeletionReason } from '@wineryxplorer/shared';

export const DELETION_REASON_LABEL: Record<DeletionReason, string> = {
  test_account: 'Test account',
  tos_violation: 'Violated TOS',
  spam: 'Spam',
  other: 'Other',
};

/** Label for a stored reason; falls back to the raw value for unknown ones. */
export const reasonLabel = (reason: string): string =>
  (DELETION_REASON_LABEL as Record<string, string | undefined>)[reason] ?? reason;

export const daysLeftLabel = (days: number): string =>
  days === 1 ? '1 day left' : `${days} days left`;

export const normalizeEmail = (value: string): string => value.trim().toLowerCase();

/** Purge-confirm gate: typed email must match the account's, trimmed and case-insensitive. */
export const emailConfirmMatches = (typed: string, email: string): boolean =>
  normalizeEmail(typed) === normalizeEmail(email);
